// import slick from 'slick-carousel';

export default (el) => {
  
  $('.logos').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    pauseOnHover: false,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
        }
      },
    ]
  });

}